// ABOUTME: Draws a link to another site the way every user text does: a new tab, with the iOS app's rel exception
// ABOUTME: One factory for plain texts (through linkifyText) and Markdown texts (whose links hold formatted words)

import type { ReactNode } from "react"

/**
 * What a text draws for every link in it. A factory, not a closure in the component: the renderer
 * is a render function called during render, and a function created during render reads as a new
 * component type to the linter. The iOS app gets no rel: with `noopener` a `_blank` link never
 * opens there.
 */
export const externalLinkRenderer =
  (isIOSApp: boolean) =>
  (href: string, children: ReactNode, key: number): ReactNode => (
    // eslint-disable-next-line react/jsx-no-target-blank -- iOS WebView: a _blank link with noopener never opens (7cf2a24f); the rule only accepts a literal rel
    <a
      href={href}
      key={key}
      rel={isIOSApp ? undefined : "noopener noreferrer"}
      target="_blank"
      className="text-blue-500 hover:underline"
    >
      {children}
    </a>
  )
